/**
 * Pages registry — THE SINGLE SOURCE OF TRUTH FOR ROUTING.
 *
 * A new page is (1) a file in `src/pages/` with a default export and (2) EXACTLY
 * ONE line in the `routes` array below. Never edit App.tsx: it builds its
 * <Route> list from here, and RouteAnnouncer publishes the same list to the
 * Upbo editor so the page shows up in its route picker.
 */
import type { ComponentType } from 'react'
import Home from '@/pages/Home'
import Collection from '@/pages/Collection'
import WatchDetail from '@/pages/WatchDetail'
import Maison from '@/pages/Maison'
import Contact from '@/pages/Contact'
import SignIn from '@/pages/SignIn'
import StudioOverview from '@/pages/StudioOverview'
import StudioListings from '@/pages/StudioListings'
import StudioEditor from '@/pages/StudioEditor'

export interface RouteDef {
  path: string
  component: ComponentType
  label?: string
  /** Shown in the editor's route list as a top-level page. */
  nav?: boolean
}

export const routes: RouteDef[] = [
  { path: '/', component: Home, label: 'Home', nav: true },
  { path: '/collection', component: Collection, label: 'Collection', nav: true },
  { path: '/collection/:id', component: WatchDetail, label: 'Watch detail', nav: false },
  { path: '/maison', component: Maison, label: 'The Maison', nav: true },
  { path: '/contact', component: Contact, label: 'Contact', nav: true },
  { path: '/signin', component: SignIn, label: 'Sign in', nav: false },
  { path: '/studio', component: StudioOverview, label: 'Studio — overview', nav: true },
  { path: '/studio/listings', component: StudioListings, label: 'Studio — manage listings', nav: true },
  { path: '/studio/new', component: StudioEditor, label: 'Studio — post a listing', nav: true },
]

export const pagesRegistry = Object.fromEntries(
  routes.map((r) => [r.path, r.component]),
) as Record<string, ComponentType>
